import * as actions from "store/actions/transfer/create";
import ITransfer from "Types/Transfer";
import dayjs from "dayjs";

export interface TransferCreateState extends ITransfer {
	loading: boolean;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: TransferCreateState = {
	loading: false,
	value: "",
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.CREATE_TRANSFER: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.CREATE_TRANSFER_SUCCESS: {
			return {
				...initialState
			};
		}
		case actions.CREATE_TRANSFER_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
